import { FETCH_ALL, CREATE, UPDATE, DELETE } from '../constants/actionTypes';

export default (dates = [], action) => {
    switch (action.type) {
        case FETCH_ALL:
            return action.payload;
        case CREATE:
            return [...dates, action.payload];
        case UPDATE:
            return dates.map((date) => date._id === action.payload._id ? action.payload : date);
        case DELETE:
            return dates.filter((date) => date._id !== action.payload);
        default:
            return dates;
    }
}